import React from 'react';

import useInsightsChatBudget from 'hooks/useInsightsChatBudget';

import InsightsChatTrigger from './InsightsChatTrigger';

// Renders the Insights chat icon only when the current user has an effective AI
// budget (group budget, per-user override, or staff). Sits inside the account
// FeatureGate, so account-level enablement is still the master switch.
const InsightsChatGate = () => {
  const { isEligible } = useInsightsChatBudget();

  if (!isEligible) {
    return null;
  }

  return <InsightsChatTrigger />;
};

export default InsightsChatGate;
